/*
 * Herói — slideshow de imagens (crossfade).
 *
 * Só roda quando a seção tem 2+ blocos "Imagem" (o Liquid só carrega este
 * arquivo nesse caso). Sem produto nas fotos, o texto e os botões ficam
 * parados e só as imagens giram. Com produto, cada foto tem o seu painel de
 * texto (data-heroi-painel) e ele troca junto.
 *
 * Regras:
 * - Respeita "reduzir movimento" do sistema: não passa sozinho.
 * - Para quando o mouse ou o teclado está sobre a área da imagem. Com painel
 *   por foto, vale para a seção inteira: ninguém clica em botão que foge.
 * - Para quando a aba não está visível.
 * - Os pontos embaixo navegam manualmente.
 * - No editor de tema, clicar num bloco "Imagem" mostra a foto dele.
 */
(function () {
  var caixas = document.querySelectorAll('[data-heroi-slideshow]');
  if (!caixas.length) return;

  var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  caixas.forEach(function (caixa) {
    var slides = Array.prototype.slice.call(caixa.querySelectorAll('.heroi__slide'));
    var pontos = Array.prototype.slice.call(caixa.querySelectorAll('.heroi__ponto'));
    if (slides.length < 2) return;

    var secao = caixa.closest('.heroi');
    var paineis = secao ? Array.prototype.slice.call(secao.querySelectorAll('[data-heroi-painel]')) : [];
    var zona = paineis.length ? secao : caixa;

    var atual = 0;
    var timer = null;
    var autoplay = caixa.dataset.autoplay === 'true' && !reduz;
    var intervalo = (parseInt(caixa.dataset.intervalo, 10) || 6) * 1000;

    function mostrar(i) {
      atual = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('heroi__slide--ativo', n === atual); });
      paineis.forEach(function (p, n) { p.classList.toggle('heroi__painel--ativo', n === atual); });
      pontos.forEach(function (p, n) {
        var on = n === atual;
        p.classList.toggle('heroi__ponto--ativo', on);
        p.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function proximo() { mostrar(atual + 1); }

    function liga() {
      if (!autoplay || timer) return;
      timer = setInterval(proximo, intervalo);
    }
    function desliga() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    pontos.forEach(function (p) {
      p.addEventListener('click', function () {
        desliga();
        mostrar(parseInt(p.dataset.heroiIr, 10) || 0);
        liga();
      });
    });

    zona.addEventListener('mouseenter', desliga);
    zona.addEventListener('mouseleave', liga);
    zona.addEventListener('focusin', desliga);
    zona.addEventListener('focusout', liga);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { desliga(); } else { liga(); }
    });

    document.addEventListener('shopify:block:select', function (evento) {
      var i = slides.indexOf(evento.target);
      if (i < 0) return;
      desliga();
      mostrar(i);
    });

    liga();
  });
})();
